import { create } from 'zustand';
import { apiService } from '../services';
import { orderBy } from 'lodash';

interface State {
    loading: boolean,
    list?: Notification[],
    getList: () => void,
    getById: (id: number) => void;
    read: (ids: number[]) => void;
}

export enum NotificationType {
    DownloadProgramDetails = 0
}

export interface Notification {
    id: number,
    parameters: any;
    createdBy: {
        id: number,
        name: string
    },
    createdUtcDate: string,
    isSelfGenerated: boolean,
    type: NotificationType,
    isUnread: boolean
}

export const useNotificationStore = create<State>((set, get) => ({
    loading: false,
    getList: async () => {
        set(() => ({ loading: true }));
        try {
            var response = await apiService.get("notification/listNotifications");
            set(() => ({ list: orderBy(response.data, x => new Date(x.createdUtcDate), 'desc') }));
        } catch (error) {
            console.error(error);
        } finally {
            set(() => ({ loading: false }));
        }
    },
    getById: async (id: number) => {
        set(() => ({ loading: true }));
        try {
            var response = await apiService.get("notification/getNotificationDownloadRequest", { params: { downloadRequest: id } });
            var newData: Notification[] = [];
            var data = get().list;
            if (data)
                newData = [...data];

            const index = newData.findIndex(x => x.id === response.data.id);
            if (index !== -1) {
                newData.splice(index, 1, response.data);
            } else {
                newData.push(response.data);
            }
            set(() => ({ list: orderBy(newData, x => new Date(x.createdUtcDate), 'desc') }));
        } catch (error) {
            console.error(error);
        } finally {
            set(() => ({ loading: false }));
        }
    },
    read: async (ids: number[]) => {
        set(() => ({ loading: true }));
        try {
            var newData: Notification[] = [];
            var data = get().list;
            if (data)
                newData = [...data];

            newData.filter(x => ids.includes(x.id)).forEach(item => {
                item.isUnread = false;
            });
            set(() => ({ list: newData }));
            await apiService.post("notification/readNotification", ids);
        } catch (error) {
            console.error(error);
        } finally {
            set(() => ({ loading: false }));
        }
    }
}))